import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { CommonLabels } from '../../../../common/models/common.model';
import { commonLabels } from '../../../../common/common.labels';
import { Router } from '@angular/router';
import { ResizeWindowService } from '../../../../common/services/resize-window.service';
import { CategoriesStoreService } from '../../../../common/services/category-observable.service';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../../environments/environment';
import { StorageService } from '../../../../common/services/storage.service';
import { ApplicationsSearchObservableService } from '../../../../common/services/applications-search-observable.service';
import jwtDecode from 'jwt-decode';

@AutoUnsubscribe()
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() isDesktop: boolean;
  @Input() width: number;
  @Input() theme: string;
  @Input() showMenu? = true;
  @Input() showMenuEcosystem? = false;
  @Input() showMenuUser? = false;
  @Input() userName: string;
  @Input() userAvatar: string;
  @Input() searchValue: string;
  @Input() isAdmin? = false;
  @Input() isCompanyAdmin? = false;
  @Output() closeMenuEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openMenuEmitter: EventEmitter<any> = new EventEmitter();
  @Output() closeMenuEcosystemEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openMenuEcosystemEmitter: EventEmitter<any> = new EventEmitter();
  @Output() closeSessionEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openMenuUserEmitter: EventEmitter<any> = new EventEmitter();
  @Output() closeMenuUserEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openWindowEmitter: EventEmitter<any> = new EventEmitter();
  @Output() closeMenuMobileEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openMenuMobileEmitter: EventEmitter<any> = new EventEmitter();
  @Output() emitInputFilter = new EventEmitter();
  @Output() emitClearFilter = new EventEmitter();
  className = 'header';
  allCompanies = [];
  labels: CommonLabels = commonLabels;
  defaultAvatar = '/assets/images/avatars/default_avatar.svg';
  protected readonly environment = environment;
  companyName: string;
  constructor(
    private router: Router,
    private categoriesStoreService: CategoriesStoreService,
    private readonly resizeWindowService: ResizeWindowService,
    private storageService: StorageService,
    private applicationsSearchObservableService: ApplicationsSearchObservableService,
    private readonly keycloak: KeycloakService
  ) {}

  async ngOnInit() {
    const token = await this.keycloak.getToken();
    if (token) {
      const data = jwtDecode(token);
      this.allCompanies = data['companyIds'] || data['companies'] || [];
    }
    this.companyName = this.storageService.getCompanyName();
  }
  openUrl(url: string, target?: string) {
    window.open(url, target !== undefined ? target : '_blank');
  }

  openMenu(): void {
    this.categoriesStoreService.setStateMenu('open');
    this.openMenuEmitter.emit('openMenu');
  }

  closeMenu(): void {
    this.categoriesStoreService.setStateMenu('close');
    this.closeMenuEmitter.emit({ action: 'closeMenu' });
  }

  openMenuEcosystem(): void {
    this.openMenuEcosystemEmitter.emit('openMenuEcosystem');
  }

  closeMenuEcosystem(): void {
    this.closeMenuEcosystemEmitter.emit('closeMenuEcosystem');
  }

  openMenuUser(): void {
    this.openMenuUserEmitter.emit('openMenuUser');
  }

  closeMenuUser(): void {
    this.closeMenuUserEmitter.emit('closeMenuUser');
  }

  openMenuMobile(): void {
    this.openMenuMobileEmitter.emit('openMenuMobile');
  }

  closeMenuMobile(): void {
    this.closeMenuMobileEmitter.emit('closeMenuMobile');
  }

  closeSession(): void {
    this.closeSessionEmitter.emit('closeSession');
  }

  navigationEditUser() {
    window.open('' + `${environment.panelUrl}/account/profile`, 'barbaraPanel');
  }

  navigationListUserCompany() {
    window.open(`${environment.panelUrl}/users/userlist`, 'barbaraPanel');
  }

  openWindow(url, target) {
    this.openWindowEmitter.emit({ url: url, target: target });
  }

  clearSearch(e) {
    this.emitClearFilter.emit(e);
  }

  search(e) {
    this.emitInputFilter.emit(e);
  }

  public logout() {
    this.keycloak.logout();
  }
  navToMulticompany() {
    this.storageService.deleteCompanyId();
    this.applicationsSearchObservableService.setSearchValue('');
    this.router.navigate(['/multicompany']);
  }

  ngOnDestroy() {}
}
